// extracted by mini-css-extract-plugin
module.exports = {"divlien":"liens_divlien__2lCeM","title":"liens_title__1V49n","partenaireDiv":"liens_partenaireDiv__8cA0p","partenaireNomDesc":"liens_partenaireNomDesc__2Bv78"};